import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { VillageDetailForm } from "@/features/village/VillageDetailForm";
import { MISSING_ID_IN_ROUTE } from "@/utils/constant";
import { useParams } from "react-router-dom";

export function VillageDetail() {
  const { id } = useParams();
  if (!id) {
    throw new Error(MISSING_ID_IN_ROUTE);
  }

  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/subdistrict",
            label: "Sub District (Kel/Desa)",
          },
          {
            label: "Detail",
          },
        ]}
      />
      <H2>Sub District (Kel/Desa) Detail</H2>
      <VillageDetailForm id={id} />
    </>
  );
}
